import { styled } from "@mui/material";
import { CheckboxProps, Checkbox } from "@mui/material";

export const StyledUncheckedIcon = styled("span")`
  border-radius: ${(props) => props.theme.wsc.radius.s};
  border: 0.063rem solid ${(props) => props.theme.wsc.palette.neutral[100]};

  .Mui-focusVisible & {
    outline: 0.2rem solid ${(props) => props.theme.wsc.palette.neutral[100]};
  }

  input:hover ~ & {
    border-width: 0.2rem;
  }

  input:disabled ~ & {
    border-color: ${(props) => props.theme.wsc.palette.neutral[300]};
  }
`;

export const StyledCheckedIcon = styled("span")`
  border-radius: ${(props) => props.theme.wsc.radius.s};
  background-image: url("data:image/svg+xml,%3Csvg width='8' height='7' viewBox='0 0 8 7' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M2.66667 6.93317L0 4.2665L0.933333 3.33317L2.66667 5.0665L7.06667 0.666504L8 1.59984L2.66667 6.93317Z' fill='%23333333'/%3E%3C/svg%3E%0A");
  background-repeat: no-repeat;
  background-color: ${(props) => props.theme.wsc.palette.neutral[100]};
  background-size: 70%;
  background-position-x: 3px;
  background-position-y: 4px;

  .Mui-focusVisible & {
    outline: 0.2rem solid ${(props) => props.theme.wsc.palette.neutral[100]};
  }

  input:disabled ~ & {
    background-color: ${(props) => props.theme.wsc.palette.neutral[300]};
  }
`;

export const StyledIndeterminateIcon = styled("span")`
  border-radius: ${(props) => props.theme.wsc.radius.s};
  background-image: url("data:image/svg+xml,%3Csvg width='8' height='2' viewBox='0 0 8 2' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Crect width='8' height='2' fill='%23333333'/%3E%3C/svg%3E%0A");
  background-repeat: no-repeat;
  background-position: center;
  background-size: 50%;
  background-color: ${(props) => props.theme.wsc.palette.neutral[100]};

  .Mui-focusVisible & {
    outline: 0.2rem solid ${(props) => props.theme.wsc.palette.neutral[100]};
  }

  input:disabled ~ & {
    background-color: ${(props) => props.theme.wsc.palette.neutral[300]};
  }
`;

export const StyledCheckbox = styled(Checkbox)<CheckboxProps>`
  padding: 0;

  .Icon {
    width: ${(props) =>
      props.size === "small" ? props.theme.wsc.size.m : props.theme.wsc.size.l};
    height: ${(props) =>
      props.size === "small" ? props.theme.wsc.size.m : props.theme.wsc.size.l};
  }

  &.Mui-checked {
    background: none;
    &.Mui-disabled,
    &:hover {
      background: none;
    }
  }

  &.Mui-disabled {
    background: none;
  }

  &.MuiCheckbox-sizeSmall {
    .IconChecked,
    .IndeterminateIcon {
      background-size: auto;
      background-position: center;
    }
  }
`;
